import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SVGModule } from '@ibe.components/common/svg/svg.module';
import { LottieAnimationViewModule } from 'ng-lottie';

import { HeaderComponent } from './header.component';
// import { TAPHeaderComponent } from './header.tap.component';
// import { HeaderFallbackComponent } from './header-fallback/header-fallback.component';
// import { HeaderFlytapMenuComponent } from './header-flytap-menu/header-flytap-menu.component';
import { INDRAHeaderFlytapMenuComponent } from './header-flytap-menu/header-flytap-menu.indra.component';

import { INDRAHeaderComponent } from './header.indra.component';
import { INDRAHeaderFallbackComponent } from './header-fallback/header-fallback.indra.component';
import { IBEAdminModule } from '@ibe.components/shared/ibe-admin.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { DirectivesModule } from 'src/app/directives/directives.module';
import { NlfLoginDropdownModule } from '@ibe.components/shared/nlf-login-dropdown/nlf-login-dropdown.module';


@NgModule({
	imports: [
		CommonModule,
		SVGModule,
		RouterModule,
		IBEAdminModule,
		PipesModule,
		LottieAnimationViewModule.forRoot(),
		DirectivesModule,
    NlfLoginDropdownModule
	],
	declarations: [
		HeaderComponent,
		// TAPHeaderComponent,
		// HeaderFallbackComponent,
		INDRAHeaderComponent,
		// HeaderFlytapMenuComponent,
		INDRAHeaderFallbackComponent,
		INDRAHeaderFlytapMenuComponent,
	],
	exports: [
		// TAPHeaderComponent
		DirectivesModule,
		INDRAHeaderComponent,
	]
})
export class HeaderModule {}
